import React, { PropsWithChildren, useState } from "react";
import { Modal as ModalAnt } from 'antd';
import './Modal.css';
import ConfirmationModal from "./CorfimationModal";

interface Props extends PropsWithChildren<any> {
    children: any
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    title: React.ReactNode;
    styledTitle?: boolean;
    onCancel?: any;
    width?: string;
    props?: any;
    askBeforeClose?: boolean;
    closable?: boolean;
}

const Modal: React.FC<Props> = ({ children, props, visible, title, styledTitle = false, width = "80%", setVisible, askBeforeClose = false, closable = true }) => {

    const [visibleClose, setVisibleClose] = useState<boolean>(false);

    return (
        // <div style={{ position: 'relative' }}>
        <>
            <ModalAnt
                className="ModalGeneral"
                footer={null}
                maskClosable={false}
                keyboard={false}
                width={width}
                title={!styledTitle ? <nav className="modalComponent_title">{title}</nav> : title}
                centered={true}
                onCancel={() => { !askBeforeClose ? setVisible(false) : setVisibleClose(true) }}
                closable={closable}
                destroyOnClose={true}
                visible={visible}
                {...props}>
                {children}
            </ModalAnt>

            <ConfirmationModal
                title={title}
                visible={visibleClose}
                setVisible={setVisibleClose}
                question="Los cambios sin guardar se perderan. ¿Seguro que deseas cerrar?"
                method={() => { setVisible(false); setVisibleClose(false) }}
                loading={false}
            />
        </>
        // </div>
    );
}



export default Modal;

